import {boolDialogCtrl} from '../../../admin/modals';
import {available_engines} from '../../../speech/speech-recognition-config.js';

require('./speech-recognition-tab.component.scss');


const EV_MICREC = '21';


class SpeechRecognitionTabController {
  constructor(
    $scope,
    $modal,
  ) {
    this.$scope = $scope;
    this.$modal = $modal;

    if ($scope.filter.id == 0) {
      $scope.filter.addFilter('agent_eventtype@default:agent_eventtype', EV_MICREC, gettext('Распознавание речи'));
      $scope.filter.addFilter('agent_attachedfile@extracted:extracted', 'false', gettext('false'));
    }

    if (!$scope.filter.speech_recognition) {
      $scope.filter.speech_recognition = {};
    }

    this.config = $scope.filter.speech_recognition;
    this.visible = $scope.currentTab == 'speech_recognition';
    this.errors = {fields: {}, error: false};  // [bw] намеренно разделено с $scope.errorMessage

    $scope.$watch('$ctrl.config', (config) => {
      if (!angular.equals(config, $scope.filter.speech_recognition)) {
        $scope.filter.speech_recognition = config;
      }
    }, true);

    $scope.$on('changeTab', () => {
      if ($scope.currentTab == 'speech_recognition') {
        this.visible = true;
        this.checkFilter();
      } else {
        this.visible = false;
      }
    });

    $scope.$on('filter-validation', (event, args) => {
      if (!event.defaultPrevented && this.visible &&
           args.filter && args.filter.content_type == 'speechrecognition' &&
           args.result && args.result.fields) {
        this.checkFilter();
      }
    });

    $scope.addOkHandler(this.handleSave.bind(this));
  }

  checkFilter() {
    let $scope = this.$scope;

    if (this.errors.error) {
      angular.forEach(this.errors.fields, (value, key) => {
        $scope.errorMessage.fields[key] = value;
      });

      $scope.errorMessage.error = true;

      if (this.errors.text && !$scope.errorMessage.text) {
        $scope.errorMessage.text = this.errors.text;
      }
    }
  }

  handleSave(handler) {
    if (this.$scope.filter.content_type != 'speechrecognition') {
      return handler;
    }

    if (this.$scope.filter.hasFilter({dimension: 'agent_eventtype@default:agent_eventtype',
                                          value: EV_MICREC})) {
      return handler;
    }

    this.$modal.open({
      templateUrl: 'boolDialog.html',
      controller: boolDialogCtrl,
      resolve: {
        message: () => gettext('Фильтрация по типу события "Запись звука" не настроена, ' +
                               'распознавание голоса будет применяться ко всем событиям! ' +
                               'Вероятнее всего это приведёт к множеству ошибок.')
      },
    }).result
    .then((result) => {
      if (result) {
        handler();
      }
    })
    .catch((error) => {
      console.error(error);
      this.$scope.errorMessage.text = angular.isString(error.data)
        ? error.data
        : angular.isObject(error.data) && angular.isString(error.data.message)
        ? error.data.message
        : gettext('Неизвестная ошибка');
      this.$scope.errorMessage.error = true;
    });
  }
}

export function SpeechRecognitionTabDirective() {
  return {
    restrict: 'E',
    template: require('./speech-recognition-tab.component.html'),
    controller: SpeechRecognitionTabController,
    controllerAs: '$ctrl',
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/tabs/speech-recognition-tab.component.js